import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './rootReducers';

const middleware = [thunk];

// Enable Redux DevTools only in development
const enhancer =
  process.env.NODE_ENV === 'development'
    ? compose(
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
          ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(applyMiddleware(...middleware))
          : applyMiddleware(...middleware)
      )
    : compose(applyMiddleware(...middleware));

const store = createStore(rootReducer, enhancer);

export default store;
